export default __webpack_public_path__ + "static/media/Categories.32ccd396.webp";